module.exports = __webpack_public_path__ + "static/media/USDC_BUSD_APE.24ee3874.png";